module.exports = __webpack_public_path__ + "static-appopensalud/img/openlegal_white.c4f5275.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/openlegal_white.svg
// module id = 1634
// module chunks = 116